import React from 'react';
import { ArrowRight } from 'lucide-react';
import { PILLARS } from '../../../config/pillars';

/**
 * ContinueCTA — rendered below a panel when its step is completed and a next step exists.
 * Shows "Step N of 7 — Continue to [pillar label]" with a Continue button.
 */
const ContinueCTA = ({ nextPillar, onSelect, completedCount }) => {
  if (!nextPillar) return null;

  return (
    <div className="mt-6 border border-[#3832e3] bg-[#3832e3]/5 p-4 sm:p-5 flex flex-col sm:flex-row items-center justify-between gap-3">
      <div className="flex items-center gap-3 text-sm">
        <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-[#3832e3] font-medium">
          Step {completedCount} of {PILLARS.length}
        </span>
        <span className="text-zinc-400 hidden sm:inline">—</span>
        <span className="font-sans text-zinc-700">
          Continue to <span className="font-medium text-black">{nextPillar.label}</span>
        </span>
      </div>
      <button
        onClick={() => onSelect(nextPillar.key)}
        className="flex items-center gap-2 px-5 py-2 bg-[#3832e3] text-white font-mono text-xs uppercase tracking-[0.15em] font-medium border border-[#3832e3] hover:bg-[#2d28b8] transition-all"
      >
        Continue
        <ArrowRight className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

export default ContinueCTA;
